import { FormControlLabel, Switch, SwitchProps } from "@mui/material";
import { useEffect, useState } from "react";

interface IProps {
	value: any;
	setValue?(value: any): void;
	updateValue?(value: any): void;
	keyValue: string;

	label?: string;
	className?: string;
	inputProps?: SwitchProps;
}

const DataSwitch = (props: IProps) => {
	const [value, setValue] = useState<boolean>(false);

	useEffect(() => {
		if (props.value && props.keyValue in props.value) {
			setValue(props.value[props.keyValue]);
		} else {
			setValue(false);
		}
	}, [props.keyValue, props.value]);

	return (
		<FormControlLabel
			control={
				<Switch
					className={props.className || ""}
					checked={value}
					onChange={(e) => {
						if (props.setValue) {
							var eventValue = props.value;
							eventValue[props.keyValue] = e.target.checked;
							props.setValue({ ...eventValue });
						}
						props.updateValue?.(e.target.checked);
					}}
					{...props.inputProps}
				/>
			}
			label={props.label || ""}
		/>
	);
};

export default DataSwitch;
